import React from 'react';

import { useComponentParamsContext } from 'lib/context/ComponentParamsContext/ComponentParamsContext';

import CurrencyInput from 'components/shared/CurrencyInput/CurrencyInput';

const OtherAdjustment = (params) => {
  const { formik } = useComponentParamsContext();
  const index = params?.node?.rowIndex;

  const onBlur = (val) => {
    const updatedProcedures = formik.values.procedures.map((p, i) => {
      if (i === index) {
        return { ...p, other_adj: val };
      }
      return p;
    });

    formik.setFieldValue('procedures', updatedProcedures);
  };

  return <CurrencyInput value={params?.value} onBlur={onBlur} variant="secondary" hideBorder />;
};

export default OtherAdjustment;
